import { Injectable } from '@angular/core'
import { LaskutHakuPyynto, LaskutHakuVastaus } from '@lemon/core-firebase/model/lasku'
import { LaskuSharedService } from '@lemon/core-firebase/service/lasku/lasku-shared.service'
import { CurrencyService } from '@lemon/core/service/currency.service'
import { DateService } from '@lemon/core/service/date.service'
import { FirebaseLemonaid } from '../../_angular/service/firebase-lemonaid.service'
import { LaskuHakuDataSource } from '../../_jaettu-angular/laskut/haku/lasku-haku.datasource'
import { LemonTranslationService } from '../../_jaettu-angular/service/lemon-translation.service'
import { TimestampService } from '../../_jaettu-angular/service/timestamp-service'

@Injectable()
export class LaskuHakuDataSourceLemonaid extends LaskuHakuDataSource {
  constructor(
    private _firebaseLemonaid: FirebaseLemonaid,
    currencyService: CurrencyService,
    dateService: DateService,
    laskuSharedService: LaskuSharedService,
    translationService: LemonTranslationService,
    timestampService: TimestampService,
  ) {
    super(currencyService, dateService, laskuSharedService, translationService, timestampService)
  }

  protected _kutsuHakua(pyynto: LaskutHakuPyynto): Promise<LaskutHakuVastaus> {
    return this._firebaseLemonaid.functionsCall<LaskutHakuPyynto, LaskutHakuVastaus>('laskutEtsiLemonSearch', pyynto, undefined, 'europe-north1')
  }
}
